(function() {
  // Configuration
  const config = {
    productGridSelector: '#product-grid',
    paginationSelector: '.pagination',
    paginationWrapperSelector: '.pagination-wrapper',
    nextButtonSelector: '.pagination__item--next',
    currentPageSelector: '.pagination__item--current',
    loadingOverlaySelector: '.loading-overlay',
    infiniteScrollLoaderSelector: '.infinite-scroll-loader',
    productGridContainerSelector: '#ProductGridContainer',
    filterFormSelector: 'form[action*="/filter"]', // Filter form selector
    filterInputSelector: 'input[name^="filter."]', // Filter inputs
    customFilterCheckboxSelector: '.cstm_facets__checkbox', // Custom filter checkbox class
    facetRemoveSelector: 'facet-remove a', // Filter removal links
    sortBySelector: '#SortBy', // Sort dropdown
    loadMoreThreshold: 300, // px from bottom of viewport
    debounceDelay: 200, // ms
    updateBrowserHistory: true, // Whether to update browser URL when loading new pages
    animateNewItems: true,
    mutationObserverDebounce: 300, // ms to debounce mutation observer callbacks
    ignoreNextURLUpdateAfterFetch: true // Don't update next URL from DOM after fetch
  };

  let isLoading = false;
  let isLastPage = false;
  let nextPageUrl = '';
  let currentPage = 1;
  let totalPages = 1;
  let debounceTimer;
  let scrollListener;
  let skipNextURLUpdate = false; // Flag to skip next URL update
  
  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log("Infinite Scroll: Initial setup");
    setupInfiniteScroll();
    setupMutationObserver();
    listenForFilterChanges();
    
  });

  // Setup MutationObserver to detect changes to the product grid container
  function setupMutationObserver() {
    const productGridContainer = document.querySelector(config.productGridContainerSelector);
    
    if (!productGridContainer) {
      console.error("Product grid not found for mutation observer");
      return;
    }
    
    console.log("Setting up MutationObserver for", config.productGridContainerSelector);
    
    let mutationTimeout = null;
    
    // Create a new MutationObserver
    const observer = new MutationObserver(function(mutations) {
      // Skip if we're currently loading more products
      if (isLoading) {
        console.log("Ignoring mutation while loading products");
        return;
      }
      
      // Debounce the mutation callbacks to avoid multiple calls in rapid succession
      clearTimeout(mutationTimeout);
      
      mutationTimeout = setTimeout(function() {
        console.log("Mutation detected in product grid container");
        
        // Only update pagination if we're not in the middle of a product load
        // This prevents overwriting the nextPageUrl after fetching a new page
        if (!skipNextURLUpdate) {
          console.log("Updating next URL due to mutation");
          // Reset pagination tracking
          nextPageUrl = '';
          isLastPage = false;
          
          // Update pagination immediately
          updateNextPageUrl();
          setupInfiniteScroll();
        } else {
          console.log("Skipping URL update after product fetch");
          skipNextURLUpdate = false;
        }
      }, config.mutationObserverDebounce);
    });
    
    // Configure and start the observer
    observer.observe(productGridContainer, {
      childList: true,      // Watch for changes to child elements
      subtree: true,        // Watch the entire subtree
      attributes: false,    // Don't need to watch attributes
      characterData: false  // Don't need to watch text content
    });
    
    console.log("MutationObserver set up successfully");
  }

  function setupInfiniteScroll() {
    console.log("Setting up infinite scroll");
    
    // Reset loading state
    isLoading = false;
    
    // Add class to body to enable infinite scroll styles
    document.body.classList.add('infinite-scroll-active');
    
    // Get the product grid
    const productGrid = document.querySelector(config.productGridSelector);
    if (!productGrid) {
      console.error("Product grid not found");
      return;
    }
    
    // Set data attribute if not already set
    if (!productGrid.getAttribute('data-infinite-scroll')) {
      productGrid.setAttribute('data-infinite-scroll', 'true');
    }
    
    // Only update the pagination and next URL if not skipping it
    if (!skipNextURLUpdate) {
      updateNextPageUrl();
    }
    
    // Remove previous scroll listener if exists
    if (scrollListener) {
      window.removeEventListener('scroll', scrollListener);
    }
    
    // Add scroll event listener with debounce
    scrollListener = function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(checkScroll, config.debounceDelay);
    };
    
    window.addEventListener('scroll', scrollListener);
    
    // Initial check in case the page is not full
    setTimeout(checkScroll, 500);
  }

  // Event listener for custom filter checkbox changes
  $(document).on('change', '.cstm_facets__checkbox', function() { 
    console.log("Custom facet checkbox changed");
    // The MutationObserver will handle updating the pagination
  });

  function listenForFilterChanges() {
    // Most filter changes will be caught by the MutationObserver,
    // but we'll keep these event listeners as a fallback

    // Listen for changes to filter forms
    document.addEventListener('click', function(event) {
      // Check if clicked element is a filter or sort control
      if (event.target.closest(config.filterFormSelector) || 
          event.target.closest(config.facetRemoveSelector) ||
          event.target.matches(config.sortBySelector)) {
        console.log("Filter/sort interaction detected");
        // The MutationObserver will handle the rest
      }
    });
    
    // Listen for form submissions (in case filters use form submit)
    document.addEventListener('submit', function(event) {
      if (event.target.matches(config.filterFormSelector)) {
        console.log("Filter form submitted");
        // The MutationObserver will handle the rest
      }
    });
    
    // Listen for custom filter events if your theme uses them
    document.addEventListener('facetFiltersUpdated', function() {
      console.log("Facet filters updated event detected");
      // The MutationObserver will handle the rest
    });

    // Initial setup
    setTimeout(function() {
      updateNextPageUrl();
      setupInfiniteScroll();
    }, 100);
    
    // Special handling for quick button filters in the 'shop-all' collection
    document.querySelectorAll('.quick_button.dev_bestselling-origin').forEach(button => {
      button.addEventListener('click', function() {
        console.log("Quick filter button clicked:", this.id);
        // The MutationObserver will handle the rest
      });
    });
  }
  
  function reinitAfterFilterChange() {
    console.log("Reinitializing after filter change");
    // Refresh pagination and next URL
    updateNextPageUrl();
    setupInfiniteScroll();
  }

  function updateNextPageUrl() {
    console.log("Updating next page URL");
    
    // If we already have a valid next page URL and we're skipping DOM updates, keep it
    if (skipNextURLUpdate && nextPageUrl && nextPageUrl.includes('/')) {
      console.log("Keeping existing next URL:", nextPageUrl);
      return;
    }
    
    // Reset last page flag to ensure we check pagination again
    isLastPage = false;
    
    const pagination = document.querySelector(config.paginationSelector);
    
    if (!pagination) {
      console.warn("Pagination not found when updating next URL");
      isLastPage = true;
      nextPageUrl = '';
      return;
    }
    
    // Get the current page number
    const currentPageElement = pagination.querySelector(config.currentPageSelector);
    if (currentPageElement) {
      currentPage = parseInt(currentPageElement.textContent.trim(), 10) || 1;
      console.log("Current page:", currentPage);
    }
    
    const nextButton = pagination.querySelector(config.nextButtonSelector);
    if (!nextButton) {
      console.warn("Next button not found when updating URL, this might be the last page");
      isLastPage = true;
      nextPageUrl = '';
      return;
    }
    
    // Always get a fresh nextPageUrl from the DOM
    // This is critical to ensure we have the correct URL that includes any active filters
    nextPageUrl = nextButton.href;
    console.log("Next page URL updated to:", nextPageUrl);
    
    // Extra validation for the URL - ensure it has proper structure
    if (!nextPageUrl || !nextPageUrl.includes('/')) {
      console.error("Invalid next page URL detected:", nextPageUrl);
      nextPageUrl = '';
      isLastPage = true;
    }
  }

  function checkScroll() {
    // If loading or determined to be last page, don't check
    if (isLoading) return;
    
    // If next page URL is empty but isLastPage isn't set, try to update the next page URL
    if (!nextPageUrl && !isLastPage) {
      console.log("Next page URL is empty but not marked as last page - updating pagination");
      skipNextURLUpdate = false; // We want to update in this case
      updateNextPageUrl();
      // If still no next URL after update, then it's the last page
      if (!nextPageUrl) {
        isLastPage = true;
        return;
      }
    }
    
    // If it's the last page, don't proceed
    if (isLastPage) return;
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;
    
    // Load more when user is near the bottom of the page
    if (pageHeight - scrollPosition < config.loadMoreThreshold) {
      loadMoreProducts();
    }
  }

  function loadMoreProducts() {
    if (isLoading || isLastPage || !nextPageUrl) return;
    isLoading = true;
    
    // Show loading spinner
    showLoadingIndicator(true);
    
    console.log("Loading more products from:", nextPageUrl);
    
    // Fetch next page
    fetch(nextPageUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => processNextPageHtml(html))
      .catch(error => {
        console.error("Error loading more products:", error);
        isLoading = false;
        skipNextURLUpdate = false;
        showLoadingIndicator(false);
      });
  }

  function processNextPageHtml(html) {
    // Create a temporary element to parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Get the new products
    const newProducts = Array.from(doc.querySelectorAll(`${config.productGridSelector} .grid__item`));
    if (newProducts.length === 0) {
      console.warn("No products found on next page");
      isLastPage = true;
      isLoading = false;
      skipNextURLUpdate = false;
      showLoadingIndicator(false);
      return;
    }
    
    console.log(`Found ${newProducts.length} new products`);
    
    // Get the product grid
    const productGrid = document.querySelector(config.productGridSelector);
    if (!productGrid) {
      console.error("Product grid not found for appending new products");
      isLoading = false;
      skipNextURLUpdate = false;
      showLoadingIndicator(false);
      return;
    }
    
    // Add animation class to new products if enabled
    if (config.animateNewItems) {
      newProducts.forEach(product => {
        product.classList.add('infinite-scroll-item-new');
      });
    }
    
    // Set flag to skip next URL update from DOM - we want to keep the URL from the fetched page
    if (config.ignoreNextURLUpdateAfterFetch) {
      skipNextURLUpdate = true;
    }
    
    // Insert new products
    newProducts.forEach(product => {
      productGrid.appendChild(document.importNode(product, true));
    });
    
    // Get the new pagination from fetched page
    const newPagination = doc.querySelector(config.paginationSelector);
    
    // Update the next page URL from the fetched page
    if (newPagination) {
      const newNextButton = newPagination.querySelector(config.nextButtonSelector);
      if (newNextButton) {
        nextPageUrl = newNextButton.href;
        console.log("Next page URL updated to from fetched page:", nextPageUrl);
      } else {
        // No more pages
        isLastPage = true;
        nextPageUrl = '';
        console.log("Reached last page");
      }
    } else {
      // No pagination found on next page
      isLastPage = true;
      nextPageUrl = '';
      console.log("No pagination found, reached last page");
    }
    
    // Re-initialize any product card JavaScript functionality
    reinitializeProductCards();
    
    // Hide loading indicator
    showLoadingIndicator(false);
    isLoading = false;
    
    // Check if we need to load more (in case the page is still not full)
    setTimeout(checkScroll, 100);
  }

  function showLoadingIndicator(show) {
    const loadingOverlay = document.querySelector(config.loadingOverlaySelector);
    const infiniteScrollLoader = document.querySelector(config.infiniteScrollLoaderSelector);
    
    if (loadingOverlay) {
      loadingOverlay.style.display = show ? 'flex' : 'none';
    }
    
    if (infiniteScrollLoader) {
      infiniteScrollLoader.style.display = show ? 'block' : 'none';
    }
  }

  function reinitializeProductCards() {
    console.log("Reinitializing product cards");
    
    // Re-initialize quick add buttons
    if (typeof theme !== 'undefined' && theme.QuickAdd) {
      theme.QuickAdd.init();
    }
    
    // Re-initialize product images hover effects
    const productCards = document.querySelectorAll('.card-wrapper');
    if (productCards.length && typeof theme !== 'undefined' && theme.initProductCard) {
      productCards.forEach(card => theme.initProductCard(card));
    }
    
    // Log the current state
    console.log("After reinitializing - Next page URL:", nextPageUrl);
    console.log("After reinitializing - Is last page:", isLastPage);
    console.log("After reinitializing - Skip next URL update:", skipNextURLUpdate);
    
    // Dispatch custom event for other scripts to hook into
    document.dispatchEvent(new CustomEvent('infiniteScroll:newProductsLoaded'));
    
    // Shopify's sections:load event triggers various section initializations
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
  }
})();